<template>
  <bm-icon
    v-if="iconFromValue"
    :icon="iconFromValue"
    :class="{ 'bm-grid-clickable': !!onClicked }"
    v-on="onClicked ? { click: onIconClick } : {}"
  />
  <div v-else>-</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { BmIconName } from "@/components/controls/bmIconMap";

interface Props {
  // If the context is appropriate the row item data this renderer is rendering a cell for.
  item?: unknown;
  value: unknown;
  onClicked?: (event: MouseEvent) => void;
}

const props = defineProps<Props>();

function onIconClick(event: MouseEvent) {
  event.stopPropagation();
  props.onClicked?.(event);
}

const iconFromValue = computed((): BmIconName | null => {
  if (typeof props.value !== "boolean") {
    return null;
  }
  return props.value ? "Check" : "Clear";
});
</script>
